import axios from 'axios';

const getForecast = async (region, env) => {

    const { REACT_APP_MONGODB_URL } = process.env;

    const request = {
        method: 'get',
        url: REACT_APP_MONGODB_URL,
        headers: { },
        params: { region: region, timestamp: new Date().toUTCString(), env: 'gold'}
    };
    
    // params: { region: region, timestamp: new Date().toUTCString()}
    let response = await axios(request)

    return response;
}

export default getForecast;